// extracted by mini-css-extract-plugin
module.exports = {"AddComment":"commentCreateForm_AddComment__XqS7s"};